import { lazy, Suspense } from 'react'

import Loading from '@/components/loading'
import AppLayout from '@/layouts/app'
import AuthLayout from '@/layouts/auth'
import { RoutePaths } from '@/shared/constants'

const route404 = {
  path: '*',
  element: () => import('@/pages/404'),
}

const routes = [
  {
    path: RoutePaths.Login,
    element: <AuthLayout />,
    auth: false,
    children: [
      {
        path: RoutePaths.Login,
        element: () => import('@/pages/auth/signin'),
      },
    ],
  },
  {
    path: RoutePaths.SignUp,
    element: <AuthLayout />,
    auth: false,
    children: [
      {
        path: RoutePaths.SignUp,
        element: () => import('@/pages/auth/signup'),
      },
    ],
  },
  // {
  //   path: '/reset-password',
  //   element: <AuthLayout />,
  //   auth: false,
  //   children: [
  //     {
  //       path: '/reset-password',
  //       element: () => import('@/pages/auth/reset-password'),
  //     },
  //   ],
  // },
  // {
  //   path: '/bind',
  //   // element: <AuthLayout />,
  //   auth: false,
  //   children: [
  //     {
  //       path: '/bind/github',
  //       element: () => import('@/pages/auth/bind/BindGitHub'),
  //     },
  //   ],
  // },
  {
    path: '/',
    children: [
      {
        path: RoutePaths.Home,
        element: () => import('@/pages/home'),
        index: true,
      },
      {
        path: RoutePaths.App,
        element: <AppLayout />,
        auth: true,
        children: [
          {
            path: '/app/overview',
            element: () => import('@/pages/app/overview/index'),
          },
          {
            path: '/app/welcome',
            element: () => import('@/pages/app/welcome/index'),
          },
          {
            path: '/app/management/*',
            element: () => import('@/pages/app/management/index'),
          },
          {
            path: '/app/member-center/*',
            element: () => import('@/pages/app/member-center/index'),
          },
          {
            path: '/app/product-center/*',
            element: () => import('@/pages/app/product-center/index'),
          },
          {
            path: '/app/project/*',
            element: () => import('@/pages/app/project/index'),
          },
          {
            path: '/app/billings/*',
            element: () => import('@/pages/app/billings/index'),
          },
          {
            path: '/app/setting/*',
            element: () => import('@/pages/app/setting/index'),
          },
        ],
      },
      {
        path: RoutePaths.Collaboration,
        children: [
          {
            path: '/collaboration/join',
            element: () => import('@/pages/app/collaboration/invite/index'),
          },
        ],
      },
      {
        path: '/403',
        element: () => import('@/pages/403'),
      },
      route404,
    ],
  },
]

export function LazyElement(props: any) {
  const { importFunc } = props
  const LazyComponent = lazy(importFunc)
  return (
    <Suspense
      fallback={
        <div className="w-full h-full flex items-center justify-center min-h-96">
          <Loading />
        </div>
      }
    >
      <LazyComponent />
    </Suspense>
  )
}

export function dealRoutes(routesArr: any) {
  if (routesArr && Array.isArray(routesArr) && routesArr.length > 0) {
    routesArr.forEach((route) => {
      if (route.element && typeof route.element == 'function') {
        const importFunc = route.element
        route.element = <LazyElement importFunc={importFunc} />
      }
      if (route.children) {
        dealRoutes(route.children)
      }
    })
  }
}
dealRoutes(routes)

export default routes
